import { ToolboxComponentOption } from "echarts/components";

type ToolboxFeatureOption = ToolboxComponentOption["feature"];

export class ToolboxBuilder {
  private feature: ToolboxFeatureOption = {};
  private show = true;

  setShow(show: boolean): this {
    this.show = show;
    return this;
  }

  withDataView(options?: Partial<ToolboxFeatureOption["dataView"]>): this {
    this.feature.dataView = {
      readOnly: true,
      backgroundColor: "#142d33",
      textareaColor: "#027680",
      textareaBorderColor: "#152125",
      textColor: "#e6f1f2",
      buttonColor: "#3aacc8",
      buttonTextColor: "#152125",
      ...options, // allows overriding defaults
    };
    return this;
  }

  withSaveAsImage(
    options?: Partial<ToolboxFeatureOption["saveAsImage"]>,
  ): this {
    this.feature.saveAsImage = {
      name: "time-series-data-graph",
      ...options,
    };
    return this;
  }

  build() {
    return {
      show: this.show,
      feature: this.feature,
    };
  }
}
